import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { useTranslation } from "react-i18next";
import Cosmetique from "images/cadeaux.png";
import PackCadeau from "images/cadeaux.png";
import parfum from "images/parfum.png";


const Section = tw.section`max-w-screen-xl mx-auto px-4 md:px-8 py-12 md:py-16`;
const Heading = tw.h2`text-2xl md:text-3xl font-extrabold text-center text-[#000000]`;
const Sub = tw.p`mt-2 text-sm md:text-base text-center text-gray-500`;

const Grid = styled.div`
  ${tw`mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4 w-full`}
`;

const Card = styled.a`
  ${tw`flex flex-col items-center text-center no-underline`}
`;

const Circle = styled.div`
  ${tw`rounded-full bg-gray-100 flex items-center justify-center overflow-hidden w-full`}
  aspect-ratio: 1 / 1;
  max-width: 260px;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
`;

const Img = styled.img`
  ${tw`object-cover`}
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 50%;
`;

const Label = tw.span`mt-3 text-xs md:text-sm font-medium text-gray-700`;
// Map category translation keys to images
const categoryItems = [
  { key: "Packs", img: PackCadeau, href: "/PackCadeaux" },
  { key: "parfums", img: parfum, href: "/parfums" },
    { key: "Cosmétique", img: Cosmetique, href: "/Cosmetique" },

];

const OurPicks = () => {
  const { t } = useTranslation();
  return (
    <Section>
      <Heading>{t("picks.heading", "Our Picks for You")}</Heading>
      <Sub>{t("picks.subtitle", "Our products are designed for everyone")}</Sub>
      <Grid>
        {categoryItems.map(({ key, img, href }) => (
          <Card key={key} href={href} aria-label={t(`categories_menu.${key}`)}>
            <Circle>
              <Img src={img} alt={t(`categories_menu.${key}`)} />
            </Circle>
            <Label>{t(`categories_menu.${key}`)}</Label>
          </Card>
        ))}
      </Grid>
    </Section>
  );
};

export default OurPicks;
